import React, { Component } from "react";
import Link from "../../../Link.js";
import commonFunction from "../../../lib/utils/common.js";
import configUrl from "../../../../config/config.json";
import { logout } from "../../../lib/logout.js";
import { checksession } from "../../../lib/checksession.js";
import { getWishList } from "../../../../shared/lib/dashboard.js";
import chat from "../../../lib/chat.js";
import FBPixCodeScript from "../../../analytics/FacebookPixelCode.js";
import Analytics from "../../../analytics/index.js";
import UploadLogo from "store/uploadLogo";
import MoreMenu from "../../Moremenu/index.js";
import GoogleTranslate from "../../googleTranslate/custom.js";
import { setCookiUserToken } from "../../../lib/login";
import { getProfileData } from "../../../../common/lib/myProfile";
import moment from "moment";
import {
  getNotifications,
  getUnreadCount,
  markNotificationRead,
  clearAllNotifications,
  clearNotification,
} from "../../../../shared/lib/notifications";
class Header11 extends Component {
  state = {
    // ...existing state...
    isWorldDropdownOpen: false,
    selectedCountry: "India",
    selectedCurrency: "INR",
    selectedLanguage: "ENG",
    profileImage: "",
    notifications: [],
    unreadCount: 0,
  };

  setWorldDropdownRef = (ref) => {
    this.worldDropdownRef = ref;
  };

  handleWorldDropdownClick = (e) => {
    e.stopPropagation();
    this.setState({ isWorldDropdownOpen: !this.state.isWorldDropdownOpen });
  };

  handleWorldDropdownOutsideClick = (event) => {
    if (
      this.worldDropdownRef &&
      !this.worldDropdownRef.contains(event.target)
    ) {
      this.setState({ isWorldDropdownOpen: false });
    }
  };

  handleWorldDropdownChange = (type, value) => {
    if (type === "country") this.setState({ selectedCountry: value });
    if (type === "currency") this.setState({ selectedCurrency: value });
    if (type === "language") this.setState({ selectedLanguage: value });
  };

  handleWorldDropdownApply = () => {
    // You can add logic to apply the selected values
    this.setState({ isWorldDropdownOpen: false });
  };

  handleWorldDropdownCancel = () => {
    this.setState({ isWorldDropdownOpen: false });
  };
  constructor() {
    super();
    this.state = {
      isShowPopup: false,
      userFirststname: "",
      userType: "",
      openInitialPopup: false,
      onHoverSupport: false,
      transform: null,
      scrolling: false,
      openSupportPopup: false,
      openCurrencyPopup: false,
      activeLink: "",
      openMorePopup: false,
      pathname: "",
      isTranslationModal: false,
      language: "en",
      isLoginDropdownOpen: false,
      isHamburgerDropdownOpen: false, // Added state for hamburger dropdown
      isProfileDropdownOpen: false, // Added state for profile dropdown
      displayName: "",
      wish_list_count: 0,
      isNotificationOpen: false,
      expandedNotifications: {},
      notificationPage: 1,
      notificationHasMore: true,
      notificationLoading: false,
      notificationTotal: 0,
    };
    this.profileDropdownRef = React.createRef();
    this.notificationRef = React.createRef();
    this.style = {
      color: "red",
    };
  }


  handleNotificationIconClick = () => {
    const isOpen = !this.state.isNotificationOpen;
    this.setState({ isNotificationOpen: isOpen, ...(!isOpen && { expandedNotifications: {}, notificationPage: 1, notificationHasMore: true }) });
    if (isOpen) {
      this.setState({ notificationLoading: true });
      getNotifications({ page: 1, limit: 20 }).then((res) => {
        const results = res?.data?.results || [];
        this.setState({
          notifications: results,
          notificationPage: 1,
          notificationHasMore: results.length === 20,
          notificationLoading: false,
          notificationTotal: res?.data?.total || 0,
        });
      });
    }
  };

  handleNotificationScroll = (e) => {
    const el = e.target;
    if (
      !this.state.notificationLoading &&
      this.state.notificationHasMore &&
      el.scrollTop + el.clientHeight >= el.scrollHeight - 10
    ) {
      const nextPage = this.state.notificationPage + 1;
      this.setState({ notificationLoading: true });
      getNotifications({ page: nextPage, limit: 20 }).then((res) => {
        const results = res?.data?.results || [];
        this.setState((prev) => ({
          notifications: [...prev.notifications, ...results],
          notificationPage: nextPage,
          notificationHasMore: results.length === 20,
          notificationLoading: false,
        }));
      });
    }
  };

  handleMarkRead = (id) => {
    markNotificationRead(id).then(() => {
      // Optimistically update local state
      this.setState((prev) => ({
        notifications: prev.notifications.map((n) =>
          n._id === id ? { ...n, is_read: true, read_at: new Date().toISOString() } : n
        ),
      }));
      // Refresh unread count from server
      getUnreadCount().then((res) => {
        this.setState({ unreadCount: res?.data || 0 });
      });
    });
  };

  handleClearAll = () => {
    clearAllNotifications().then(() => {
      this.setState({ notifications: [], notificationTotal: 0, isNotificationOpen: false, expandedNotifications: {}, notificationPage: 1, notificationHasMore: true });
      getUnreadCount().then((res) => {
        this.setState({ unreadCount: res?.data || 0 });
      });
    });
  };

  handleClearOne = (id) => {
    // Mark as read first, then clear
    markNotificationRead(id).then(() => {
      clearNotification(id).then(() => {
        this.setState((prev) => ({
          notifications: prev.notifications.filter((n) => n._id !== id),
          notificationTotal: Math.max((prev.notificationTotal || 1) - 1, 0),
        }));
        getUnreadCount().then((res) => {
          this.setState({ unreadCount: res?.data || 0 });
        });
      });
    });
  };

  fetchWishlistData() {
    getWishList().then(async (res) => {
      if (res?.data?.status) {
        this.setState({ wish_list_count: res?.data.count });
      }
    })
  }

  componentDidMount() {
    this.fetchWishlistData();
    getUnreadCount().then((res) => {
      this.setState({ unreadCount: res?.data || 0 });
    });
    // Poll unread count every 60 seconds
    this.unreadCountInterval = setInterval(() => {
      getUnreadCount().then((res) => {
        this.setState({ unreadCount: res?.data || 0 });
      });
    }, 15000);
    document.addEventListener(
      "mousedown",
      this.handleWorldDropdownOutsideClick
    );
    let url = window.location.pathname;
    if (this.props?.data?.siteData?.site?.allow_multilingual) {
      let googtransCookie = commonFunction.getCookie("googtrans");
      let language =
        googtransCookie != "" ? googtransCookie.split("/")[2] : "en";
      this.setState({ language });
    }
    this.setState({ pathname: url });

    let defaultService = this.props.data.headermenu.menu?.filter(
      (ele) => ele.status.toLowerCase() == "active"
    );
    if (defaultService?.length > 0) {
      this.setState({ activeLink: defaultService[0]?.code });
    }

    if (url.includes("holiday") || url.includes("holidays")) {
      this.setState({ activeLink: "Holidays" });
    }
    if (url.includes("flight") || url.includes("flights")) {
      this.setState({ activeLink: "Flights" });
    }
    if (url.includes("hotel") || url.includes("hotels")) {
      this.setState({ activeLink: "Hotels" });
    }
    if (url.includes("activity") || url.includes("activities")) {
      this.setState({ activeLink: "Activities" });
    }
    if (url.includes("car") || url.includes("cars")) {
      this.setState({ activeLink: "Cabs" });
    }
    //check if varification token is there
    window.addEventListener("scroll", this.handleScroll);
    document.addEventListener("mousedown", this.handleCalendarClickOutside);
    document.addEventListener("mousedown", this.handleClickOutside);
    document.addEventListener(
      "mousedown",
      this.handleHamburgerDropdownOutsideClick
    );
    chat(this.props?.data?.siteData?.site?.chat, this.props?.data?.isMobile);

    if (this.props?.data?.user?.status) {
      this.setState({
        userFirststname: this.props?.data?.user?.first_name
          ? this.props?.data?.user?.first_name.charAt(0)
          : this.props?.data?.user?.email.charAt(0),
        userType: this.props?.data?.user?.type,
      });
    } else {
      this.setState({
        userFirststname: "",
        userType: "",
      });
    }
    // this.checkSessionApi()

    // Call getProfileData if accessToken is present
    if (this.props?.data?.user?.accessToken) {
      // Get siteid the same way as elsewhere in the file
      let siteid = this.props?.data?.site_id;
      let accessToken = this.props?.data?.user?.accessToken;
      getProfileData({ siteid, accessToken }).then((data) => {
        const profile = data?.data?.data[0];
        this.setState({
          profileImage: profile?.profile_image,
          displayName: profile?.display_name || "",
        });
      });
    }

    if (!this.props?.data?.user?.accessToken) {
      const urlParams = new URLSearchParams(window.location.search);
      const nativeview = urlParams.get("nativeview");
      const userToken = urlParams.get("userToken");

      if (
        (nativeview == "true" || localStorage.getItem("nativeView")) &&
        userToken
      ) {
        let userTokenReq = {
          userToken: userToken,
        };

        setCookiUserToken(userTokenReq).then((responseJSON) => {
          if (
            responseJSON.status === true &&
            responseJSON.accessToken !== "" &&
            responseJSON.accessToken !== undefined &&
            responseJSON.accessToken !== null
          ) {
            window.location.reload();
          }
        });
      }
    }

    document.addEventListener(
      "mousedown",
      this.handleProfileDropdownOutsideClick
    );
    document.addEventListener(
      "mousedown",
      this.handleNotificationOutsideClick
    );
  }

  componentWillUnmount = () => {
    clearInterval(this.unreadCountInterval);
    document.removeEventListener(
      "mousedown",
      this.handleWorldDropdownOutsideClick
    );
    document.removeEventListener("mousedown", this.handleCalendarClickOutside);
    document.removeEventListener("mousedown", this.handleClickOutside);
    document.removeEventListener(
      "mousedown",
      this.handleHamburgerDropdownOutsideClick
    );
    document.removeEventListener(
      "mousedown",
      this.handleProfileDropdownOutsideClick
    );
    document.removeEventListener(
      "mousedown",
      this.handleNotificationOutsideClick
    );
    window.removeEventListener("scroll", this.handleScroll);
  };

  handleNotificationOutsideClick = (event) => {
    if (
      this.notificationRef.current &&
      !this.notificationRef.current.contains(event.target) &&
      this.state.isNotificationOpen
    ) {
      this.setState({ isNotificationOpen: false, expandedNotifications: {}, notificationPage: 1, notificationHasMore: true });
    }
  };

  handleProfileDropdownOutsideClick = (event) => {
    if (
      this.profileDropdownRef.current &&
      !this.profileDropdownRef.current.contains(event.target) &&
      this.state.isProfileDropdownOpen
    ) {
      this.setState({ isProfileDropdownOpen: false });
    }
  };

  setCalendarWrapperRef = (node) => {
    this.calendarWrapperRef = node;
  };

  setSupportWrapperRef = (node) => {
    this.supportWrapperRef = node;
  };
  setMoreWrapperRef = (node) => {
    this.MoreWrapperRef = node;
  };

  setCurrencyWrapperRef = (node) => {
    this.currencyWrapperRef = node;
  };

  setHamburgerDropdownRef = (ref) => {
    this.hamburgerDropdownRef = ref;
  };

  handleScroll = (event) => {
    if (window.scrollY <= 250 && this.state.scrolling === true) {
      this.setState({ scrolling: false });
    } else if (window.scrollY > 250 && this.state.scrolling !== true) {
      this.setState({ scrolling: true });
    }
  };

  handleCalendarClickOutside = (event) => {
    if (
      !this.calendarWrapperRef ||
      !this.calendarWrapperRef.contains(event.target)
    ) {
      this.setState({ openInitialPopup: false });
    }

    if (
      !this.supportWrapperRef ||
      !this.supportWrapperRef.contains(event.target)
    ) {
      this.setState({ openSupportPopup: false });
    }
    if (!this.MoreWrapperRef || !this.MoreWrapperRef.contains(event.target)) {
      this.setState({ openMorePopup: false });
    }

    if (
      !this.currencyWrapperRef ||
      !this.currencyWrapperRef.contains(event.target)
    ) {
      this.setState({ openCurrencyPopup: false });
    }
  };

  handleHamburgerDropdownOutsideClick = (event) => {
    if (
      this.hamburgerDropdownRef &&
      !this.hamburgerDropdownRef.contains(event.target) &&
      this.state.isHamburgerDropdownOpen
    ) {
      this.setState({ isHamburgerDropdownOpen: false });
    }
  };

  checkSessionApi = () => {
    if (
      !commonFunction.isValueEmpty(this?.props?.data?.sessionData) &&
      !commonFunction.isValueEmpty(this?.props?.data?.sessionData) &&
      this?.props?.data?.sessionData?.status === true
    ) {
      this.setState(
        {
          userFirststname:
            !commonFunction.isValueEmpty(
              this?.props?.data?.sessionData?.email
            ) &&
            (!commonFunction.isValueEmpty(
              this?.props?.data?.sessionData?.first_name
            )
              ? this?.props?.data?.sessionData?.first_name.charAt(0)
              : this?.props?.data?.sessionData?.email.charAt(0)),
          userType:
            !commonFunction.isValueEmpty(
              this?.props?.data?.sessionData?.type
            ) && this?.props?.data?.sessionData?.type,
        },
        () => { }
      );
    } else {
      this.setState({
        userFirststname: "",
        userType: "",
      });
    }
  };

  onClickArrow = () => {
    this.setState({
      isShowPopup: !this.state.isShowPopup,
    });
  };

  onMouseLeave = () => {
    this.setState({
      isShowPopup: false,
    });
  };

  // componentWillReceiveProps(state, props) {
  //     this.checkSessionApi()
  // }

  onClickProfile = () => {
    // commonFunction.redirectTo('/myprofile')
    window.location.href = "/myprofile";
  };

  onClickLogout = () => {
    this.props.data.onClickHeaderLogin("logout", "logout", {});
    return;
    logout()
      .then((responseJSON) => {
        if (
          responseJSON.status === true ||
          responseJSON.message === "Logout successfull"
        ) {
          this.setState({
            userFirststname: "",
            userType: "",
          });
          // location.reload()

          if (this.props?.data?.siteData?.site?.business_b2b) {
            window.location.pathname != "/login"
              ? (window.location.href = "/login")
              : null;
          } else {
            window.location.reload();
            // commonFunction.redirectTo("/");
          }
        } else {
        }
      })
      .catch((err) => { });
  };

  myBookingClickHandler = () => {
    // commonFunction.redirectTo('/myprofile', { Linkindex: 1 })
    window.location.href = `/myprofile?Linkindex=1`;
  };

  setMorePopupHandler = () => {
    this.setState({
      openMorePopup: !this.state.openMorePopup,
    });
  };

  closeTranslationModal = () => {
    this.setState({ isTranslationModal: false });
  };

  // Handle dropdown click for mobile
  handleDropdownClick = (e) => {
    if (window.innerWidth <= 768) {
      e.preventDefault();
      this.setState({ isLoginDropdownOpen: !this.state.isLoginDropdownOpen });
    }
  };

  handleImageError = (event) => {
    event.target.onerror = null
    event.target.src = 'images/userplaceholder.svg'
  }

  // Handle outside click to close dropdown
  handleClickOutside = (event) => {
    if (this.dropdownRef && !this.dropdownRef.contains(event.target)) {
      this.setState({ isLoginDropdownOpen: false });
    }
  };

  // Set dropdown ref
  setDropdownRef = (ref) => {
    this.dropdownRef = ref;
  };
  // User type configuration
  getUserTypes() {
    return [
      {
        role: "Tour Master",
        icon: "fas fa-map-signs",
        login: "/login/tour-master",
        register: "/register/tour-master",
        roleSrc: "/images/te_Tour_Master_user.svg",
      },
      {
        role: "Traveler",
        icon: "fas fa-user",
        login: "/login/traveler",
        register: "/register/traveler",
        roleSrc: "/images/te_Profile.svg",
      },
      {
        role: "Vendor",
        icon: "fas fa-store",
        login: "/login/vendor",
        register: "/register/vendor",
        roleSrc: "/images/te_Vendor.svg",
      },
    ];
  }

  render() {
    const signupStyle = {
      border: "1px solid #3479c5",
      margin: 12,
      borderRadius: 10,
    };

    const loginStyle = {
      border: "1px solid #3479c5",
      backgroundColor: "var(--buttons_color)",
      margin: 12,
      borderRadius: 10,
    };

    const activeTabStyle = {
      backgroundColor: "#cc0000",
    };

    return (
      <>
        <header className={this.props.data.cssfile.header} data-name="Header">
          <div className={this.props.data.cssfile.header_main_wrapper}>
            {/* Logo */}
            <div
              className={this.props.data.cssfile.logo_container}
              data-name="Logo-TripButter 1"
            >
              <div className={this.props.data.cssfile.logo_image}>
                {this.props?.data?.user?.rg_type === "vendor" ? (
                  // Vendor case — show image only, no link
                  <img
                    src={
                      "/shared/api/media/" +
                      this.props?.data?.siteData?.data?.header?.logo
                    }
                    alt="logo"
                  />
                ) : (
                  // Non-vendor case — image inside a link
                  <Link title="Logo" key="logo" href="/" className="">
                    <img
                      src={
                        "/shared/api/media/" +
                        this.props?.data?.siteData?.data?.header?.logo
                      }
                      alt="logo"
                    />
                  </Link>
                )}
              </div>
            </div>
            {/* Navigation Menu */}

            {this.props?.data?.user?.rg_type === "vendor" ? null : (
              <nav className={this.props.data.cssfile.nav_menu}>
                <div className={this.props.data.cssfile.nav_item}  onClick={() => {
                      commonFunction.redirectTo("/holiday/destination", "");
                    }}>
                  <div className={this.props.data.cssfile.nav_icon}>
                    <img
                      src="images/destination.svg"
                      alt="Destinations Icon"
                    />
                  </div>
                  <span
                    className={this.props.data.cssfile.nav_text}
                   
                  >
                    Destinations
                  </span>
                </div>
                <div className={this.props.data.cssfile.nav_item} onClick={() => {
                      commonFunction.redirectTo("/tourpackages", "");
                    }}>
                  <div className={this.props.data.cssfile.nav_icon}>
                    <img src="images/holiday_icon.svg" alt="Holidays Icon" />
                  </div>
                  <span
                    className={this.props.data.cssfile.nav_text}
                  >
                    Holidays
                  </span>
                </div>
                <div className={this.props.data.cssfile.nav_item}  onClick={() => {
                      commonFunction.redirectTo("/holiday/tourmaster", "");
                    }}>
                  <div className={this.props.data.cssfile.nav_icon}>
                    <img
                      src="images/tour_master.svg"
                      alt="Tour Masters Icon"
                    />
                  </div>
                  <span
                    className={this.props.data.cssfile.nav_text}
                  >
                    Tour Masters
                  </span>
                </div>
                <div
                  className={`${this.props.data.cssfile.nav_item} ${this.props.data.cssfile.offer_icon}`}
                >
                  {/* <div className={this.props.data.cssfile.nav_icon}>
                  <img src="images/Offer_icon.svg" alt="Offers Icon" />
                </div>
                <span className={this.props.data.cssfile.nav_text}>Offers</span> */}
                </div>
              </nav>
            )}
            {/* Right side actions */}
            <div className={this.props.data.cssfile.header_actions}>
              {/* If user is NOT logged in (no accessToken) */}
              {!this.props?.data?.user?.accessToken ? ( // revert to original "!this.props?.data?.user?.accessToken" --- IGNORE ---
                <>
                  {this.props?.data?.user?.rg_type === "vendor" ? null : (
                    <button
                      className={this.props.data.cssfile.become_tour_master_btn}
                      onClick={() => {
                        commonFunction.redirectTo("/registration", "");
                      }}
                    >
                      Become a Tour Master
                    </button>
                  )}
                  <div
                    className={`${this.props.data.cssfile.login_section} 
                    ${this.state.isLoginDropdownOpen
                        ? this.props.data.cssfile.login_text_dropdown_active
                        : ""
                      }`}
                    ref={this.setDropdownRef}
                    onClick={this.handleDropdownClick}
                  >
                    <div className={this.props.data.cssfile.login_icon}>
                      <img src="images/tour_user_icon.svg" alt="Login Icon" />
                    </div>
                    <span
                      className={this.props.data.cssfile.login_text}
                      onClick={(e) => {
                        e.stopPropagation();
                        this.setState({
                          isLoginDropdownOpen: !this.state.isLoginDropdownOpen,
                        });
                      }}
                      style={{ cursor: "pointer" }}
                    >
                      Login / Register
                    </span>
                    {this.state.isLoginDropdownOpen && (
                      <div
                        className={this.props.data.cssfile.dropdown_menu_wrap}
                      >
                        <ul
                          className={
                            this.props.data.cssfile.login_dropdown_menu
                          }
                        >
                          {this.getUserTypes().map((item, idx) => (
                            <li
                              key={idx}
                              className={
                                this.props.data.cssfile.login_dropdown_item
                              }
                            >
                              <div
                                className={
                                  this.props.data.cssfile.login_dropdown_role
                                }
                              >
                                <div
                                  className={this.props.data.cssfile.role_icon}
                                >
                                  <img
                                    src={
                                      item.roleSrc
                                        ? item.roleSrc
                                        : "images/tour_user_icon.svg"
                                    }
                                    alt={`profile Icon`}
                                  />
                                </div>
                                <div
                                  className={
                                    this.props.data.cssfile.role_details
                                  }
                                >
                                  <span
                                    className={
                                      this.props.data.cssfile.role_text
                                    }
                                  >
                                    {item.role}
                                  </span>
                                </div>
                              </div>
                              <div
                                className={this.props.data.cssfile.login_links}
                              >
                                <button
                                  onClick={(e) => {
                                    e.preventDefault();
                                    this.setState({
                                      isLoginDropdownOpen: false,
                                    });
                                    if (item.role === "Vendor") {
                                      this.props.data.onClickHeaderLogin(
                                        "vendor_login",
                                        "vendor_login",
                                        { userType: item.role }
                                      );
                                      localStorage.setItem("regis", item.role);
                                    } else {
                                      this.props.data.onClickHeaderLogin(
                                        "LoginWithMobile",
                                        "login",
                                        { userType: item.role }
                                      );
                                      localStorage.setItem("regis", item.role);
                                    }
                                  }}
                                  className={this.props.data.cssfile.login_link}
                                  title={`Login as ${item.role}`}
                                >
                                  Login
                                </button>
                                <span
                                  className={
                                    this.props.data.cssfile.link_separator
                                  }
                                >
                                  |
                                </span>
                                <button
                                  onClick={(e) => {
                                    e.preventDefault();
                                    this.setState({
                                      isLoginDropdownOpen: false,
                                    });
                                    item.role === "Tour Master"
                                      ? commonFunction.redirectTo(
                                        "/registration",
                                        ""
                                      )
                                      : item.role === "Vendor"
                                        ? commonFunction.redirectTo("/vendor", "")
                                        : this.props.data.onClickHeaderLogin(
                                          "Register",
                                          "Register",
                                          {
                                            userType: item.role,
                                          }
                                        );
                                  }}
                                  className={
                                    this.props.data.cssfile.register_link
                                  }
                                  title={`Register as ${item.role}`}
                                >
                                  Register
                                </button>
                              </div>
                            </li>
                          ))}
                        </ul>
                        <ul
                          className={this.props.data.cssfile.menu_item_bottom}
                        >
                          <li
                            className={
                              this.props.data.cssfile
                                .hamburger_dropdown_listItem
                            }
                          >
                            <a
                              href="/about-us"
                              className={
                                this.props.data.cssfile.hamburger_dropdown_link
                              }
                            >
                              About Trip Butter
                            </a>
                          </li>
                          <li
                            className={
                              this.props.data.cssfile
                                .hamburger_dropdown_listItem
                            }
                          >
                            <a
                              href="/fnq"
                              className={
                                this.props.data.cssfile.hamburger_dropdown_link
                              }
                            >
                              FAQs
                            </a>
                          </li>
                          <li
                            className={
                              this.props.data.cssfile
                                .hamburger_dropdown_listItem
                            }
                          >
                            <a
                              href="/contact-us"
                              className={
                                this.props.data.cssfile.hamburger_dropdown_link
                              }
                            >
                              Contact
                            </a>
                          </li>
                        </ul>
                      </div>
                    )}
                  </div>
                </>
              ) : (
                // If user IS logged in (accessToken exists)
                <>
                  <div className={this.props.data.cssfile.header_user}>
                    {this.props?.data?.user?.rg_type === "vendor" ? null : (
                      <div
                        className={
                          this.props.data.cssfile.header_user__icon_group
                        }
                      >
                        <div
                          ref={this.notificationRef}
                          className={`${this.props.data.cssfile.header_user__icon} ${this.props.data.cssfile.notification_wrapper}`}
                          onClick={this.handleNotificationIconClick}
                          style={{ cursor: "pointer" }}
                        >
                          {/* // Bell icon IMG */}
                          <img
                            className={
                              this.props.data.cssfile.header_user__icon_bell
                            }
                            src="/images/te_notification_icon.svg"
                            alt="Notifications"
                            width="24"
                            height="24"
                          />
                          {this.state?.unreadCount?.unreadCount > 0 && (
                            <span className={this.props.data.cssfile.header_user__badge}>
                              {this.state?.unreadCount?.unreadCount}
                            </span>
                          )}
                          {this.state.isNotificationOpen && (
                            <div
                              className={this.props.data.cssfile.notification_dropdown}
                              onClick={(e) => e.stopPropagation()}
                            >
                              <div className={this.props.data.cssfile.notification_header}>
                                <span className={this.props.data.cssfile.notification_title}>
                                  Notifications ({this.state.notificationTotal})
                                </span>
                                <button
                                  className={this.props.data.cssfile.notification_clear_all}
                                  onClick={this.handleClearAll}
                                >
                                  Clear All
                                </button>
                              </div>
                              <ul
                                className={this.props.data.cssfile.notification_list}
                                onScroll={this.handleNotificationScroll}
                              >
                                {this.state.notifications?.length > 0 ? (
                                  this.state.notifications.map((item, idx) => {
                                    const timeAgo = (dateStr) => {
                                      if (!dateStr) return '';
                                      const m = moment(dateStr);
                                      const now = moment();
                                      const mins = now.diff(m, 'minutes');
                                      const hrs = now.diff(m, 'hours');
                                      const days = now.diff(m, 'days');
                                      if (mins < 1) return 'Just Now';
                                      if (mins < 60) return `${mins} min${mins > 1 ? 's' : ''} ago`;
                                      if (hrs < 24) return `${hrs} hr${hrs > 1 ? 's' : ''} ago`;
                                      if (days === 1) return 'Yesterday';
                                      if (days <= 7) return `${days} days ago`;
                                      return m.format('DD-MMM-YYYY');
                                    };
                                    const isExpanded = this.state.expandedNotifications[item._id];
                                    const TRUNCATE = 53;
                                    const isTruncatable = item.message?.length > TRUNCATE;
                                    const displayMessage = isTruncatable && !isExpanded
                                      ? item.message.slice(0, TRUNCATE)
                                      : item.message;
                                    return (
                                      <li key={item._id || idx} className={`${this.props.data.cssfile.notification_item} ${!item.is_read ? this.props.data.cssfile.notification_unread : ''}`}
                                        onClick={() => { if (!item.is_read) this.handleMarkRead(item._id); }}
                                        style={{ cursor: !item.is_read ? 'pointer' : 'default' }}
                                      >
                                        <span className={this.props.data.cssfile.notification_dot} />
                                        <div className={this.props.data.cssfile.notification_content}>
                                          {item.title && (
                                            <p className={this.props.data.cssfile.notification_item_title}>
                                              {item.title}
                                            </p>
                                          )}
                                          <p className={this.props.data.cssfile.notification_message}>
                                            {displayMessage}
                                            {isTruncatable && !isExpanded && (
                                              <span
                                                className={this.props.data.cssfile.notification_show_more}
                                                onClick={(e) => { e.stopPropagation(); this.setState({ expandedNotifications: { ...this.state.expandedNotifications, [item._id]: true } }); this.handleMarkRead(item._id); }}
                                              >… Show More</span>
                                            )}
                                            {isTruncatable && isExpanded && (
                                              <span
                                                className={this.props.data.cssfile.notification_show_more}
                                                onClick={(e) => { e.stopPropagation(); this.setState({ expandedNotifications: { ...this.state.expandedNotifications, [item._id]: false } }); }}
                                              > Show Less</span>
                                            )}
                                          </p>
                                          {item.reference_data?.total_booking_amount > 0 && (
                                            <span className={this.props.data.cssfile.notification_amount}>
                                              {item.reference_data.currency_symbol}{item.reference_data.total_booking_amount?.toLocaleString()}
                                            </span>
                                          )}
                                          <div className={this.props.data.cssfile.notification_footer}>
                                            <span className={this.props.data.cssfile.notification_time}>
                                              {timeAgo(item.createdAt)}
                                            </span>
                                          </div>
                                        </div>
                                        <button
                                          className={this.props.data.cssfile.notification_close}
                                          onClick={(e) => { e.stopPropagation(); this.handleClearOne(item._id); }}
                                        >
                                          ×
                                        </button>
                                      </li>
                                    );
                                  })
                                ) : (
                                  !this.state.notificationLoading && <li className={this.props.data.cssfile.notification_empty}>No notifications</li>
                                )}
                                {this.state.notificationLoading && (
                                  <li className={this.props.data.cssfile.notification_loading}>Loading…</li>
                                )}
                              </ul>
                            </div>
                          )}
                        </div>
                        <div
                          className={this.props.data.cssfile.header_user__icon}
                          onClick={() => {
                            window.location.href =
                              "/myprofile?activeTab=wishlist";
                          }}
                        >
                          {/* Heart icon IMG */}
                          <img
                            className={
                              this.props.data.cssfile.header_user__icon_heart
                            }
                            src="images/te_wishlish.svg"
                            alt="Favorites"
                            width="24"
                            height="24"
                          />
                          {this.state.wish_list_count > 0 && <span
                            className={
                              this.props.data.cssfile.header_user__badge
                            }
                          >
                            {this.state.wish_list_count || 0}
                          </span>}
                        </div>
                      </div>
                    )}
                    <div
                      className={this.props.data.cssfile.header_user__profile}
                      ref={this.profileDropdownRef}
                    >
                      <img
                        className={this.props.data.cssfile.header_user__avatar}
                        src={`${this.state.profileImage
                          ? `/shared/api/media/${this.state.profileImage}`
                          : "images/userplaceholder.svg"
                          }`}
                        alt="User avatar"
                        style={{ cursor: "pointer" }}
                        onClick={() =>
                          this.setState({
                            isProfileDropdownOpen:
                              !this.state.isProfileDropdownOpen,
                          })
                        }
                        onError={this.handleImageError}
                      />

                      <span
                        className={this.props.data.cssfile.header_user__name}
                        style={{ cursor: "pointer" }}
                        onClick={() =>
                          this.setState({
                            isProfileDropdownOpen:
                              !this.state.isProfileDropdownOpen,
                          })
                        }
                      >
                        {this.state.displayName || this.props?.data?.user?.first_name || "User"}
                      </span>
                      <img
                        className={
                          this.props.data.cssfile.header_user__dropdown
                        }
                        src="images/te_register_drop_icon.svg"
                        alt="Dropdown Arrow"
                        width="16"
                        height="16"
                        style={{ cursor: "pointer" }}
                        onClick={() =>
                          this.setState({
                            isProfileDropdownOpen:
                              !this.state.isProfileDropdownOpen,
                          })
                        }
                      />
                      {this.state.isProfileDropdownOpen && (
                        <div
                          className={`${this.props.data.cssfile.dropdown_menu_wrap} ${this.props.data.cssfile.login_dropdown_position}`}
                        >
                          <ul
                            className={
                              this.props.data.cssfile.login_dropdown_menu
                            }
                          >
                            <li
                              className={
                                this.props.data.cssfile.hamburger_dropdown_item
                              }
                            >
                              <span
                                className={
                                  this.props.data.cssfile
                                    .hamburger_dropdown_icon
                                }
                              >
                                <img
                                  src="images/eth_my_account.svg"
                                  alt="User Icon"
                                />
                              </span>
                              <button
                                className={
                                  this.props.data.cssfile.hamburger_dropdown_btn
                                }
                                onClick={this.onClickProfile}
                              >
                                My Account
                              </button>
                            </li>
                            <li
                              className={
                                this.props.data.cssfile.login_seperatot
                              }
                            ></li>

                            <li
                              className={
                                this.props.data.cssfile.hamburger_dropdown_item
                              }
                            >
                              <span
                                className={
                                  this.props.data.cssfile
                                    .hamburger_dropdown_icon
                                }
                              >
                                <img
                                  src="images/eth_logout.svg"
                                  alt="User Icon"
                                />
                              </span>

                              <button
                                className={
                                  this.props.data.cssfile.hamburger_dropdown_btn
                                }
                                onClick={this.onClickLogout}
                              >
                                Logout
                              </button>
                            </li>
                          </ul>
                        </div>
                      )}
                    </div>
                  </div>
                </>
              )}
              {/* World and hamburger icons always visible */}

              {this.props?.data?.user?.rg_type === "vendor" ? null : (
                <>
                  <div
                    className={
                      this.state.isWorldDropdownOpen
                        ? `${this.props.data.cssfile.world_icon_wrap} ${this.props.data.cssfile.world_icon_wrap_active}`
                        : `${this.props.data.cssfile.action_icon} ${this.props.data.cssfile.world_icon_wrap}`
                    }
                    ref={this.setWorldDropdownRef}
                  >
                    <img
                      className={this.props.data.cssfile.world__icon}
                      src="images/world_icon.svg"
                      alt="World Icon"
                      style={{ cursor: "pointer" }}
                      onClick={this.handleWorldDropdownClick}
                    />
                    {this.state.isWorldDropdownOpen && (
                      <div
                        className={
                          this.props.data.cssfile.dropdown_menu_wrap +
                          " " +
                          this.props.data.cssfile.world_dropdown_position
                        }
                      >
                        <div
                          className={
                            this.props.data.cssfile.world_dropdown_container
                          }
                        >
                          {/* Country Field */}
                          <div
                            className={
                              this.props.data.cssfile.world_dropdown_field +
                              " " +
                              this.props.data.cssfile
                                .world_dropdown_field_country
                            }
                          >
                            <label
                              className={
                                this.props.data.cssfile.world_dropdown_label
                              }
                            >
                              Country
                            </label>
                            <div
                            // className={
                            //   this.props.data.cssfile
                            //     .world_dropdown_input_wrap
                            // }
                            >

                              <div
                                className={`flex items-center bg-white ${this.props.data.cssfile.world_dropdown_input}`}
                              >
                                <img
                                  src="images/india_flag_icon.svg"
                                  alt="India"
                                  className="w-5 h-5 mr-2"
                                />
                                <span className={this.props.data.cssfile.dropdown_second_field}>India</span>
                                <input type="hidden" name="country" value="India" />
                                <img src="images/te_register_drop_icon.svg" className={this.props.data.cssfile.globe_dropdown_icon} alt="Icon" />
                              </div>
                            </div>
                          </div>

                          {/* Currency Field */}
                          <div
                          // className={
                          //   this.props.data.cssfile.world_dropdown_field +
                          //   " " +
                          //   this.props.data.cssfile
                          //     .world_dropdown_field_currency
                          // }
                          >
                            <label
                              className={
                                this.props.data.cssfile.world_dropdown_label
                              }
                            >
                              Currency
                            </label>
                            <div
                            // className={
                            //   this.props.data.cssfile
                            //     .world_dropdown_input_wrap
                            // }
                            >
                              <div
                                className={`flex items-center bg-white ${this.props.data.cssfile.world_dropdown_input}`}
                              >
                                <span className={this.props.data.cssfile.dropdown_first_field}>INR</span>
                                <span className={this.props.data.cssfile.dropdown_second_field}>Indian Rupee</span>
                                <input type="hidden" name="currency" value="INR" />
                                <img src="images/te_register_drop_icon.svg" className={this.props.data.cssfile.globe_dropdown_icon} alt="Icon" />
                              </div>
                              {/* <input
                                type="text"
                                value="INR"
                                readOnly
                                className={
                                  this.props.data.cssfile.world_dropdown_input
                                }
                              />
                              <img
                                src="images/te_register_drop_icon.svg"
                                alt="Icon"
                              /> */}
                            </div>
                          </div>

                          {/* Language Field */}
                          <div
                            className={
                              this.props.data.cssfile.world_dropdown_field +
                              " " +
                              this.props.data.cssfile
                                .world_dropdown_field_language
                            }
                          >
                            <label
                              className={
                                this.props.data.cssfile.world_dropdown_label
                              }
                            >
                              Language
                            </label>
                            <div
                            // className={
                            //   this.props.data.cssfile
                            //     .world_dropdown_input_wrap
                            // }
                            >
                              <div
                                className={`flex items-center bg-white ${this.props.data.cssfile.world_dropdown_input}`}
                              >
                                <span className={this.props.data.cssfile.dropdown_first_field}>ENG</span>
                                <span className={this.props.data.cssfile.dropdown_second_field}>English</span>
                                <input type="hidden" name="currency" value="ENG" />
                                <img src="images/te_register_drop_icon.svg" className={this.props.data.cssfile.globe_dropdown_icon} alt="Icon" />
                              </div>
                              {/* <input
                                type="text"
                                value="English"
                                readOnly
                                className={
                                  this.props.data.cssfile.world_dropdown_input
                                }
                              />
                              <img
                                src="images/te_register_drop_icon.svg"
                                alt="Icon"
                              /> */}
                            </div>
                          </div>

                          {/* Buttons */}
                          {/* <div
                            className={
                              this.props.data.cssfile.world_button_wrapper
                            }
                          >
                            <button
                              className={
                                this.props.data.cssfile.world_dropdown_apply_btn
                              }
                              onClick={this.handleWorldDropdownApply}
                            >
                              Apply
                            </button>
                            <button
                              className={
                                this.props.data.cssfile
                                  .world_dropdown_cancel_btn
                              }
                              onClick={this.handleWorldDropdownCancel}
                            >
                              Cancel
                            </button>
                          </div> */}
                        </div>
                      </div>
                    )}
                  </div>
                  <div
                    className={
                      this.state.isHamburgerDropdownOpen
                        ? this.props.data.cssfile.action_icon_active
                        : this.props.data.cssfile.action_icon
                    }
                  >
                    <img
                      className={this.props.data.cssfile.action__icon}
                      src="images/hamburger_icon.svg"
                      alt="Hamburger Icon"
                      style={{ cursor: "pointer" }}
                      onClick={(e) => {
                        e.stopPropagation();
                        this.setState({
                          isHamburgerDropdownOpen:
                            !this.state.isHamburgerDropdownOpen,
                        });
                      }}
                    />
                    {this.state.isHamburgerDropdownOpen && (
                      <div
                        className={
                          this.props.data.cssfile.hamburger_dropdown_wrap
                        }
                        ref={this.setHamburgerDropdownRef}
                      >
                        <ul
                          className={
                            this.props.data.cssfile.hamburger_dropdown_menu
                          }
                        >
                          {/* ...existing code... */}
                          {this.props?.data?.user?.accessToken ? (
                            <>
                              <li
                                className={
                                  this.props.data.cssfile
                                    .hamburger_dropdown_item
                                }
                              >
                                <span
                                  className={
                                    this.props.data.cssfile
                                      .hamburger_dropdown_icon
                                  }
                                >
                                  <img
                                    src="images/tour_user_icon.svg"
                                    alt="User Icon"
                                  />
                                </span>
                                <span
                                  className={
                                    this.props.data.cssfile
                                      .hamburger_dropdown_btn
                                  }
                                >
                                  {this.state.displayName || this.props?.data?.user?.first_name || "User"}
                                </span>
                              </li>
                              <li
                                className={
                                  this.props.data.cssfile
                                    .hamburger_dropdown_item
                                }
                              >
                                <span
                                  className={
                                    this.props.data.cssfile
                                      .hamburger_dropdown_icon
                                  }
                                >
                                  <img
                                    src="images/eth_my_account.svg"
                                    alt="User Icon"
                                  />
                                  <i
                                    className={`fas fa-user ${this.props.data.cssfile.hamburger_dropdown_icon}`}
                                  ></i>
                                </span>
                                <button
                                  className={
                                    this.props.data.cssfile
                                      .hamburger_dropdown_btn
                                  }
                                  onClick={this.onClickProfile}
                                >
                                  My Account
                                </button>
                              </li>
                              <li
                                className={
                                  this.props.data.cssfile
                                    .hamburger_dropdown_item
                                }
                              >
                                <span
                                  className={
                                    this.props.data.cssfile
                                      .hamburger_dropdown_icon
                                  }
                                >
                                  <img
                                    src="images/eth_logout.svg"
                                    alt="User Icon"
                                  />
                                  <i
                                    className={`fas fa-sign-out-alt ${this.props.data.cssfile.hamburger_dropdown_icon}`}
                                  ></i>
                                </span>
                                <button
                                  className={
                                    this.props.data.cssfile
                                      .hamburger_dropdown_btn
                                  }
                                  onClick={this.onClickLogout}
                                >
                                  Logout
                                </button>
                              </li>
                              <li
                                className={
                                  this.props.data.cssfile
                                    .hamburger_dropdown_divider
                                }
                              ></li>
                            </>
                          ) : (
                            <>
                              <li
                                className={
                                  this.props.data.cssfile
                                    .hamburger_dropdown_item
                                }
                              >
                                <span
                                  className={
                                    this.props.data.cssfile
                                      .hamburger_dropdown_icon
                                  }
                                >
                                  <img
                                    src="images/te_blue_rightarrow.svg"
                                    alt="User Icon"
                                  />
                                </span>
                                <button
                                  className={
                                    this.props.data.cssfile
                                      .hamburger_dropdown_btn
                                  }
                                  onClick={() =>
                                    commonFunction.redirectTo(
                                      "/registration",
                                      ""
                                    )
                                  }
                                >
                                  Become a Tour Master
                                </button>
                              </li>
                              <li
                                className={
                                  this.props.data.cssfile
                                    .hamburger_dropdown_item
                                }
                              >
                                <span
                                  className={
                                    this.props.data.cssfile
                                      .hamburger_dropdown_icon
                                  }
                                >
                                  <img
                                    src="images/te_blue_rightarrow.svg"
                                    alt="User Icon"
                                  />
                                </span>
                                <button
                                  className={
                                    this.props.data.cssfile
                                      .hamburger_dropdown_btn
                                  }
                                  onClick={() =>
                                    this.props.data.onClickHeaderLogin(
                                      "Register",
                                      "Register",
                                      {
                                        userType: "Traveler",
                                      }
                                    )
                                  }
                                >
                                  Become a Traveler
                                </button>
                              </li>
                              <li
                                className={
                                  this.props.data.cssfile
                                    .hamburger_dropdown_item
                                }
                              >
                                <span
                                  className={
                                    this.props.data.cssfile
                                      .hamburger_dropdown_icon
                                  }
                                >
                                  <img
                                    src="images/te_blue_rightarrow.svg"
                                    alt="User Icon"
                                  />
                                </span>
                                <button
                                  className={
                                    this.props.data.cssfile
                                      .hamburger_dropdown_btn
                                  }
                                  onClick={() =>
                                    commonFunction.redirectTo("/vendor", "")
                                  }
                                >
                                  Become a Vendor
                                </button>
                              </li>
                              <li
                                className={
                                  this.props.data.cssfile
                                    .hamburger_dropdown_divider
                                }
                              ></li>
                            </>
                          )}
                          {/* ...existing code... */}
                          <li
                            className={
                              this.props.data.cssfile
                                .hamburger_dropdown_listItem
                            }
                          >
                            <a
                              href="/about-us"
                              className={
                                this.props.data.cssfile.hamburger_dropdown_link
                              }
                            >
                              About Trip Butter
                            </a>
                          </li>
                          <li
                            className={
                              this.props.data.cssfile
                                .hamburger_dropdown_listItem
                            }
                          >
                            <a
                              href="/fnq"
                              className={
                                this.props.data.cssfile.hamburger_dropdown_link
                              }
                            >
                              FAQs
                            </a>
                          </li>
                          <li
                            className={
                              this.props.data.cssfile
                                .hamburger_dropdown_listItem
                            }
                          >
                            <a
                              href="/contact-us"
                              className={
                                this.props.data.cssfile.hamburger_dropdown_link
                              }
                            >
                              Contact
                            </a>
                          </li>
                        </ul>
                      </div>
                    )}
                  </div>
                </>
              )}
            </div>
          </div>
        </header>
      </>
    );
  }
}

export default Header11;
